// Suggafoot's theme JS

document.documentElement.classList.add('sf-js');

(function () {
  var catalogEl = document.getElementById('sf-product-catalog');
  var modal = document.getElementById('sf-product-modal');
  if (!catalogEl || !modal) return;

  var catalog = {};
  try {
    catalog = JSON.parse(catalogEl.textContent);
  } catch (e) {
    return;
  }

  var titleEl = document.getElementById('sf-product-modal-title');
  var badgesEl = modal.querySelector('[data-sf-product-modal-badges]');
  var bioEl = modal.querySelector('.sf-product-modal-bio');
  var featuresEl = modal.querySelector('[data-sf-product-modal-features]');
  var priceEl = modal.querySelector('.sf-product-modal-price');
  var packWrap = modal.querySelector('[data-sf-product-modal-pack-wrap]');
  var packSelect = modal.querySelector('[data-sf-product-modal-pack-select]');
  var packDetail = modal.querySelector('[data-sf-product-modal-pack-detail]');
  var packLabelEl = modal.querySelector('[data-sf-product-modal-pack-label]');
  var galleryWrap = modal.querySelector('[data-sf-product-modal-gallery]');
  var galleryImage = modal.querySelector('[data-sf-product-modal-image]');
  var galleryThumbs = modal.querySelector('[data-sf-product-modal-thumbs]');
  var activeItem = null;

  function renderGallery(images) {
    if (!galleryWrap || !galleryImage) return;
    var list = images || [];
    if (!list.length) {
      galleryWrap.hidden = true;
      if (galleryThumbs) galleryThumbs.innerHTML = '';
      return;
    }
    galleryWrap.hidden = false;
    galleryImage.src = list[0].url;
    galleryImage.alt = list[0].alt || '';
    if (!galleryThumbs) return;
    galleryThumbs.innerHTML = '';
    list.forEach(function (img, index) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sf-product-modal-thumb' + (index === 0 ? ' is-active' : '');
      btn.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
      btn.setAttribute('aria-label', img.alt || 'Product photo');
      var thumbImg = document.createElement('img');
      thumbImg.src = img.url;
      thumbImg.alt = '';
      thumbImg.loading = 'lazy';
      btn.appendChild(thumbImg);
      btn.addEventListener('click', function () {
        galleryImage.src = img.url;
        galleryImage.alt = img.alt || '';
        galleryThumbs.querySelectorAll('.sf-product-modal-thumb').forEach(function (el) {
          el.classList.remove('is-active');
          el.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      });
      galleryThumbs.appendChild(btn);
    });
  }

  function renderFeatures(features) {
    if (!featuresEl) return;
    featuresEl.innerHTML = '';
    (features || []).forEach(function (feature) {
      var li = document.createElement('li');
      li.textContent = feature;
      featuresEl.appendChild(li);
    });
  }

  function updatePackSelection() {
    if (!activeItem || !activeItem.packOptions || !packSelect) return;
    var choice = activeItem.packChoices[packSelect.value];
    if (packDetail && choice) {
      var detail = choice.detail || '';
      packDetail.textContent = detail;
      packDetail.hidden = !detail;
    }
    if (priceEl && choice && choice.price) {
      priceEl.textContent = choice.price;
    }
  }

  function getFirstPackChoice(item) {
    var keys = Object.keys(item.packChoices || {});
    if (!keys.length) return null;
    return item.packChoices[keys[0]];
  }

  function openModal(id) {
    var item = catalog[id];
    if (!item) return;
    activeItem = item;

    if (titleEl) titleEl.textContent = item.title;
    if (badgesEl) badgesEl.textContent = item.badges || '';
    if (bioEl) bioEl.textContent = item.bio || '';
    renderFeatures(item.features);
    renderGallery(item.images);

    if (packWrap) {
      if (item.packOptions) {
        packWrap.hidden = false;
        if (packLabelEl) {
          packLabelEl.textContent = item.packLabel || 'Choose option';
        }
        if (packSelect) {
          packSelect.innerHTML = '';
          Object.keys(item.packChoices || {}).forEach(function (key) {
            var choice = item.packChoices[key];
            var option = document.createElement('option');
            option.value = key;
            option.textContent = choice.label;
            packSelect.appendChild(option);
          });
          var firstKey = Object.keys(item.packChoices || {})[0];
          if (firstKey) packSelect.value = firstKey;
        }
        var firstChoice = getFirstPackChoice(item);
        if (priceEl) {
          priceEl.textContent =
            (firstChoice && firstChoice.price) || item.price || '';
        }
        updatePackSelection();
      } else {
        packWrap.hidden = true;
        if (packDetail) packDetail.textContent = '';
        if (priceEl) priceEl.textContent = item.price || '';
      }
    } else if (priceEl) {
      priceEl.textContent = item.price || '';
    }

    modal.classList.add('sf-open');
    modal.setAttribute('aria-hidden', 'false');
  }

  function closeModal() {
    modal.classList.remove('sf-open');
    modal.setAttribute('aria-hidden', 'true');
    activeItem = null;
  }

  if (packSelect) {
    packSelect.addEventListener('change', updatePackSelection);
  }

  document.querySelectorAll('[data-sf-product-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      var id = trigger.getAttribute('data-sf-product-trigger');
      if (!id) return;
      event.preventDefault();
      openModal(id);
    });
  });

  modal.addEventListener('click', function (event) {
    if (event.target === modal) closeModal();
  });

  modal.querySelectorAll('[data-sf-product-modal-close]').forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });
})();

(function () {
  document.querySelectorAll('[data-sf-bottle-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-sf-bottle-gallery-main]');
    if (!main) return;
    gallery.querySelectorAll('[data-sf-bottle-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-src') || '';
        main.alt = thumb.getAttribute('data-alt') || '';
        var w = thumb.getAttribute('data-width');
        var h = thumb.getAttribute('data-height');
        if (w && h) {
          main.width = w;
          main.height = h;
        } else {
          main.removeAttribute('width');
          main.removeAttribute('height');
        }
        gallery.querySelectorAll('[data-sf-bottle-thumb]').forEach(function (el) {
          el.classList.remove('is-active');
          el.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });
  });
})();

(function () {
  var header = document.querySelector('.sf-header');
  var toggle = document.querySelector('.sf-nav-toggle');
  var nav = document.getElementById('sf-main-nav');
  if (!header || !toggle || !nav) return;

  function setNavOpen(open) {
    header.classList.toggle('sf-header--nav-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('sf-nav-open', open);
  }

  toggle.addEventListener('click', function () {
    setNavOpen(!header.classList.contains('sf-header--nav-open'));
  });

  nav.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      setNavOpen(false);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setNavOpen(false);
  });
})();

(function () {
  function cartAddEndpoint() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + 'cart/add.js';
    }
    return '/cart/add.js';
  }

  function cartPageUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.cart_url) {
      return Shopify.routes.cart_url;
    }
    return '/cart';
  }

  function lineItemPropertiesFromForm(formData) {
    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (!match || value == null) return;
      var trimmed = String(value).trim();
      if (trimmed) properties[match[1]] = trimmed;
    });
    return Object.keys(properties).length ? properties : undefined;
  }

  function bindCartForms() {
    document.querySelectorAll('[data-sf-cart-form], form.sf-product-form').forEach(function (form) {
      if (form.dataset.sfCartBound === 'true') return;
      form.dataset.sfCartBound = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var formData = new FormData(form);
        var variantId = formData.get('id');
        var quantity = parseInt(formData.get('quantity') || '1', 10);

        if (!variantId) {
          window.alert('Choose an option before adding to cart.');
          return;
        }

        if (!quantity || quantity < 1) quantity = 1;

        var item = { id: Number(variantId), quantity: quantity };
        var properties = lineItemPropertiesFromForm(formData);
        if (properties) item.properties = properties;

        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        fetch(cartAddEndpoint(), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [item],
          }),
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then(function (result) {
            if (result.ok) {
              window.location.href = cartPageUrl();
              return;
            }
            var message =
              (result.data && (result.data.description || result.data.message)) ||
              'Could not add to cart. Please try again.';
            window.alert(message);
          })
          .catch(function () {
            window.alert('Could not add to cart. Refresh the page and try again.');
          })
          .finally(function () {
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    });
  }

  bindCartForms();
  document.addEventListener('shopify:section:load', bindCartForms);
})();

(function () {
  var cartRoot = document.querySelector('[data-sf-cart]');
  if (!cartRoot) return;

  function cartApiUrl(path) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root + path;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function itemLabel(count) {
    return count === 1 ? '1 item' : count + ' items';
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('a[href*="/cart"]').forEach(function (link) {
      if (/cart\s*\(/i.test(link.textContent)) {
        link.textContent = 'Cart (' + count + ')';
      }
    });
  }

  function setLineLoading(line, loading) {
    if (!line) return;
    line.classList.toggle('sf-cart-item--updating', loading);
    line.querySelectorAll('[data-sf-qty-minus], [data-sf-qty-plus], [data-sf-cart-qty-input], [data-sf-cart-remove]').forEach(function (el) {
      el.disabled = loading;
    });
  }

  function syncCartUi(cart) {
    var subtotalEl = cartRoot.querySelector('[data-sf-cart-subtotal]');
    var metaEl = cartRoot.querySelector('[data-sf-cart-meta]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (metaEl) metaEl.textContent = itemLabel(cart.item_count);
    updateHeaderCount(cart.item_count);

    if (!cart.item_count) {
      window.location.reload();
      return;
    }

    var itemsByKey = {};
    cart.items.forEach(function (item) {
      itemsByKey[item.key] = item;
    });

    cartRoot.querySelectorAll('[data-sf-cart-line]').forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var item = itemsByKey[key];
      if (!item) {
        line.remove();
        return;
      }
      var input = line.querySelector('[data-sf-cart-qty-input]');
      var linePrice = line.querySelector('[data-sf-cart-line-price]');
      if (input) input.value = item.quantity;
      if (linePrice) linePrice.textContent = formatMoney(item.final_line_price);
    });
  }

  function changeLineQuantity(lineKey, quantity, line) {
    setLineLoading(line, true);

    return fetch(cartApiUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var message =
            (result.data && (result.data.description || result.data.message)) ||
            'Could not update your cart.';
          window.alert(message);
          return;
        }
        syncCartUi(result.data);
      })
      .catch(function () {
        window.alert('Could not update your cart. Please try again.');
      })
      .finally(function () {
        setLineLoading(line, false);
      });
  }

  function clampQty(value) {
    value = parseInt(value, 10);
    if (isNaN(value) || value < 0) value = 0;
    return value;
  }

  cartRoot.querySelectorAll('[data-sf-cart-line]').forEach(function (line) {
    var lineKey = line.getAttribute('data-line-key');
    var input = line.querySelector('[data-sf-cart-qty-input]');
    var minus = line.querySelector('[data-sf-qty-minus]');
    var plus = line.querySelector('[data-sf-qty-plus]');
    var removeBtn = line.querySelector('[data-sf-cart-remove]');
    var debounceTimer;

    function queueUpdate(nextQty) {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () {
        changeLineQuantity(lineKey, nextQty, line);
      }, 350);
    }

    if (minus) {
      minus.addEventListener('click', function () {
        var nextQty = Math.max(0, clampQty(input.value) - 1);
        input.value = nextQty;
        window.clearTimeout(debounceTimer);
        changeLineQuantity(lineKey, nextQty, line);
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        var nextQty = clampQty(input.value) + 1;
        input.value = nextQty;
        window.clearTimeout(debounceTimer);
        changeLineQuantity(lineKey, nextQty, line);
      });
    }

    if (input) {
      input.addEventListener('change', function () {
        var nextQty = clampQty(input.value);
        if (nextQty < 1) nextQty = 1;
        input.value = nextQty;
        window.clearTimeout(debounceTimer);
        changeLineQuantity(lineKey, nextQty, line);
      });

      input.addEventListener('input', function () {
        if (input.value === '') return;
        var nextQty = clampQty(input.value);
        if (nextQty < 1) return;
        queueUpdate(nextQty);
      });
    }

    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        window.clearTimeout(debounceTimer);
        changeLineQuantity(lineKey, 0, line);
      });
    }
  });
})();

(function () {
  var sections = {
    shop: document.getElementById('shop'),
    recipes: document.getElementById('recipes'),
  };

  function scrollToSection(id, behavior) {
    var section = sections[id];
    if (!section) return;
    section.scrollIntoView({ behavior: behavior || 'smooth', block: 'start' });
  }

  function isHomepage() {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    return path === '/';
  }

  document.querySelectorAll('a[href*="#shop"], a[href*="#recipes"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (!isHomepage()) return;
      var hash = link.hash || (link.href.split('#')[1] ? '#' + link.href.split('#')[1] : '');
      var id = hash.replace('#', '');
      if (!sections[id]) return;
      event.preventDefault();
      scrollToSection(id, 'smooth');
      if (history.replaceState) {
        history.replaceState(null, '', hash);
      } else {
        window.location.hash = id;
      }
    });
  });

  var initialId = window.location.hash.replace('#', '');
  if (sections[initialId]) {
    window.requestAnimationFrame(function () {
      scrollToSection(initialId, 'auto');
    });
  }
})();

(function () {
  var zoomRoot = document.getElementById('sf-image-zoom');
  if (!zoomRoot) return;

  var zoomImg = zoomRoot.querySelector('[data-sf-image-zoom-img]');
  var zoomCaption = zoomRoot.querySelector('[data-sf-image-zoom-caption]');
  var zoomLevel = zoomRoot.querySelector('[data-sf-zoom-level]');
  var zoomInBtn = zoomRoot.querySelector('[data-sf-zoom-in]');
  var zoomOutBtn = zoomRoot.querySelector('[data-sf-zoom-out]');
  var scale = 1;
  var minScale = 1;
  var maxScale = 3;
  var step = 0.25;

  function updateZoomLevel() {
    if (zoomLevel) zoomLevel.textContent = Math.round(scale * 100) + '%';
    if (zoomImg) zoomImg.style.setProperty('--sf-zoom-scale', String(scale));
    if (zoomOutBtn) zoomOutBtn.disabled = scale <= minScale;
    if (zoomInBtn) zoomInBtn.disabled = scale >= maxScale;
  }

  function openZoom(src, alt) {
    if (!zoomImg || !src) return;
    scale = 1;
    updateZoomLevel();
    zoomImg.src = src;
    zoomImg.alt = alt || '';
    if (zoomCaption) zoomCaption.textContent = alt || '';
    zoomRoot.classList.add('sf-open');
    zoomRoot.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sf-zoom-open');
  }

  function closeZoom() {
    zoomRoot.classList.remove('sf-open');
    zoomRoot.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sf-zoom-open');
    if (zoomImg) {
      zoomImg.removeAttribute('src');
      zoomImg.alt = '';
    }
  }

  function changeZoom(delta) {
    scale = Math.min(maxScale, Math.max(minScale, scale + delta));
    updateZoomLevel();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-sf-gallery-zoom-trigger]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      var img =
        trigger.querySelector('[data-sf-product-modal-image]') ||
        trigger.querySelector('[data-sf-bottle-gallery-main]') ||
        trigger.querySelector('img');
      if (img && img.src) {
        openZoom(img.currentSrc || img.src, img.alt);
      }
      return;
    }

    if (event.target.closest('[data-sf-image-zoom-close]')) {
      event.preventDefault();
      closeZoom();
    }
  });

  if (zoomInBtn) {
    zoomInBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      changeZoom(step);
    });
  }

  if (zoomOutBtn) {
    zoomOutBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      changeZoom(-step);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && zoomRoot.classList.contains('sf-open')) {
      event.stopPropagation();
      closeZoom();
    }
  });
})();

(function () {
  function stripPrivateAddress(html) {
    return html
      .replace(/14230 Ventura Blvd, #318, Sherman Oaks, CA,? 91423,? US/gi, '')
      .replace(/ or contact us at\s*,/g, '.')
      .replace(/please call\s*or email us at/g, 'please email us at')
      .replace(/<p>Suggafoot Inc\.\s*,\s*<\/p>/g, '')
      .replace(/<p>\s*<\/p>/g, '');
  }

  document.querySelectorAll('.shopify-policy__body, .shopify-policy__body .rte').forEach(function (el) {
    el.innerHTML = stripPrivateAddress(el.innerHTML);
    if (/suggafoot90@gmail\.com/i.test(el.innerHTML)) {
      el.innerHTML = el.innerHTML
        .replace(/mailto:suggafoot90@gmail\.com/gi, 'mailto:chefsuggafoot@gmail.com')
        .replace(/suggafoot90@gmail\.com/gi, 'chefsuggafoot@gmail.com');
    }
  });
})();

(function () {
  var chefIntro = document.querySelector('.sf-home-chef-intro .sf-chef-intro-copy');
  if (chefIntro) {
    var eyebrow = chefIntro.querySelector('.sf-chef-intro-eyebrow');
    if (eyebrow) eyebrow.remove();
    var heading = chefIntro.querySelector('.sf-chef-intro-heading');
    if (heading && /chef'?s touch/i.test(heading.textContent || '')) {
      heading.textContent = 'From Chef Suggafoot';
    }
  }
})();

(function () {
  var chefText = document.querySelector('.sf-home-chef-intro .sf-chef-intro-text');
  if (!chefText) return;
  if (/Suggafoot's|global flavor/i.test(chefText.textContent || '')) {
    chefText.textContent =
      'Executive Chef Marsha Garnett built Suggafoot from a lifelong kitchen ministry. Global flavor, clean organic ingredients, and soul in every pour.';
  }
})();

(function () {
  var recipesContainer = document.querySelector('.sf-home-recipes .sf-container');
  if (!recipesContainer) return;
  var leadText =
    "Bright salads, savory noodles, and weeknight mains — all made better with Suggafoot's Organic Asian Sesame dressing and marinade.";
  var lead = recipesContainer.querySelector('.sf-recipes-lead');
  if (!lead) {
    var header = recipesContainer.querySelector('.sf-recipes-header');
    if (header) {
      lead = document.createElement('p');
      lead.className = 'sf-text-muted sf-recipes-lead';
      lead.textContent = leadText;
      header.insertAdjacentElement('afterend', lead);
    }
  } else if (/organic Asian sesame/i.test(lead.textContent || '')) {
    lead.textContent = lead.textContent.replace(/organic Asian sesame/gi, 'Organic Asian Sesame');
  }
})();

(function () {
  var chefStoryHeading = document.querySelector('.sf-chef-story-page .sf-heading-lg');
  if (!chefStoryHeading) return;
  if (/Soul, Service, and Serious Flavor/i.test(chefStoryHeading.textContent || '') || /Chef Suggafoot:/i.test(chefStoryHeading.textContent || '')) {
    chefStoryHeading.textContent = 'More Than a Dressing—A Legacy in Every Bottle.';
  }
})();

(function () {
  var contactCard = document.querySelector('.sf-card-soft');
  if (!contactCard) return;
  var heading = contactCard.querySelector('.sf-heading-lg');
  if (heading && /Reach/i.test(heading.textContent || '')) {
    heading.textContent = 'Suggafoot, Inc.';
  }
  var copy = contactCard.querySelector('.sf-text-muted');
  if (copy && !copy.querySelector('a[href*="wholesale"]') && /Wholesale & Retail page/i.test(copy.innerHTML)) {
    copy.innerHTML = copy.innerHTML.replace(
      'Wholesale &amp; Retail page',
      '<a href="/pages/wholesale-retail-buyers">Wholesale &amp; Retail</a> page'
    );
  }
})();

(function () {
  var founderEyebrow = document.querySelector('.sf-founder-story .sf-founder-eyebrow');
  if (founderEyebrow) founderEyebrow.remove();
})();

(function () {
  var founderLead = document.querySelector('.sf-founder-story .sf-founder-lead');
  if (!founderLead) return;
  if (/Cooking was never just cooking/i.test(founderLead.textContent || '')) {
    founderLead.textContent = "Chef's Story";
  }
})();

(function () {
  var buyerLink = document.querySelector('.sf-wholesale-contact a[href^="mailto:"]');
  if (!buyerLink) return;
  if (/suggafoot90@gmail\.com/i.test(buyerLink.textContent || '')) {
    buyerLink.textContent = 'chefsuggafoot@gmail.com';
    buyerLink.href = 'mailto:chefsuggafoot@gmail.com';
  }
})();
